export default __webpack_public_path__ + "static/141-min-min-f644824faeb29e8d69914aa5eccbf6cd.jpg";